export default __webpack_public_path__ + "static/media/america.4f40325d.png";